import { useApi } from '@mainstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { WEBHOOKS_NOTIFICATIONS_KEY } from './reactQuery';
import { notificationApiRef } from '../notificationApiRef';
import { NotificationBindingPatchRequest } from '@agilelab/plugin-wb-notification-common';

export const useUpdateNotificationBinding = (options?: {
  alertOnError?: boolean;
}) => {
  const notificationApi = useApi(notificationApiRef);
  const alertApi = useApi(customAlertApiRef);
  const queryClient = useQueryClient();

  const defaultOnSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: [WEBHOOKS_NOTIFICATIONS_KEY],
    });
    alertApi.post({
      severity: 'success',
      message: 'Notification trigger updated successfully',
    });
  };

  return useMutation({
    mutationFn: (request: NotificationBindingPatchRequest) =>
      notificationApi.patchNotificationBinding(request),
    onSuccess: defaultOnSuccess,
    onError: e => {
      if (options?.alertOnError === false) return;
      alertApi.post({
        severity: 'error',
        message: (e instanceof Error ? e : new Error('Something went wrong'))
          .message,
      });
    },
  });
};
